export const SelectStyling = {
    defaultProps: {
        variant: 'flushed',
        focusBorderColor: "blackFocus",
        size: "sm"
    }
}